"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyNetworkRoute = exports.MyNetworkRouteDefaultProps = exports.MY_NETWORK_QUERY = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var client_1 = require("@apollo/client");
var use_lang_1 = require("../../../hooks/use-lang");
var lodash_1 = require("lodash");
var use_active_person_1 = require("../../../hooks/use-active-person");
var app_loader_1 = require("../../app/app-loader");
var entity_list_section_1 = require("../../entities/entity-list-section");
var graphql_1 = require("../../../utils/graphql");
exports.MY_NETWORK_QUERY = (0, graphql_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query MyNetworkQuery($id: ID!) {\n    person(id: $id) {\n      id\n      name\n      slug\n      role { id name }\n      position\n      positions {\n        id name slug\n        organisation { ...EntityValueFields }\n      }\n      chapterRoles {\n        id\n        slug\n        role {\n          id\n          slug\n          name \n        }\n        chapter {\n          ...EntityValueFields\n          people {\n            id\n            name\n          }\n        }\n      }\n      teamRoles {\n        id\n        slug\n        team {\n          ...EntityValueFields\n          members {\n            id\n            person {\n              ...EntityValueFields\n              organisation { ...EntityValueFields }\n              location { ...EntityValueFields }\n              position\n            }\n          }\n        }\n      }\n      organisation {\n        positions {\n          id\n          slug\n          position\n          person {\n            ...EntityValueFields\n            organisation {\n              id name slug\n            }\n            bio { id plainTruncated: plain(truncate: { words: 20 }) }\n            position\n            location { id name slug }\n          }\n        }\n      }\n    }\n\n  }\n"], ["\n  query MyNetworkQuery($id: ID!) {\n    person(id: $id) {\n      id\n      name\n      slug\n      role { id name }\n      position\n      positions {\n        id name slug\n        organisation { ...EntityValueFields }\n      }\n      chapterRoles {\n        id\n        slug\n        role {\n          id\n          slug\n          name \n        }\n        chapter {\n          ...EntityValueFields\n          people {\n            id\n            name\n          }\n        }\n      }\n      teamRoles {\n        id\n        slug\n        team {\n          ...EntityValueFields\n          members {\n            id\n            person {\n              ...EntityValueFields\n              organisation { ...EntityValueFields }\n              location { ...EntityValueFields }\n              position\n            }\n          }\n        }\n      }\n      organisation {\n        positions {\n          id\n          slug\n          position\n          person {\n            ...EntityValueFields\n            organisation {\n              id name slug\n            }\n            bio { id plainTruncated: plain(truncate: { words: 20 }) }\n            position\n            location { id name slug }\n          }\n        }\n      }\n    }\n\n  }\n"])));
exports.MyNetworkRouteDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(2))
});
var TeamsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var PeopleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ChaptersStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Chapters: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ChaptersStyles),
  Teams: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TeamsStyles),
  People: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), PeopleStyles)
};
var MyNetworkRoute = function (props) {
  var className = props.className;
  var activePerson = (0, use_active_person_1.useActivePerson)().person;
  var t = (0, use_lang_1.useLang)();
  var _a = (0, client_1.useQuery)(exports.MY_NETWORK_QUERY, {
      variables: {
        id: activePerson.id
      }
    }),
    data = _a.data,
    loading = _a.loading;
  var person = data && data.person;
  var personId = person && person.id;
  // people is everyone in your organisation and everyone in your teams
  var orgPeople = (person && person.organisation && person.organisation.positions || []).map(function (position) {
    return position.person;
  });
  var teams = (person && person.teamRoles || []).map(function (teamRole) {
    return teamRole.team;
  });
  var chapters = (person && person.chapterRoles || []).map(function (chapterRole) {
    return chapterRole.chapter;
  });
  var teamPeople = (0, lodash_1.filter)((0, lodash_1.flatten)(teams.map(function (team) {
    return (team.members || []).map(function (teamRole) {
      return teamRole.person;
    });
  })));
  var chapterPeople = (0, lodash_1.filter)((0, lodash_1.flatten)(chapters.map(function (chapter) {
    return (chapter.roles || []).map(function (role) {
      return role.person;
    });
  })));
  var people = (0, lodash_1.uniqBy)((0, lodash_1.filter)(__spreadArray(__spreadArray(__spreadArray([], __read(orgPeople), false), __read(teamPeople), false), __read(chapterPeople), false), function (orgPerson) {
    return orgPerson.id !== personId;
  }), function (p) {
    return p.id;
  });
  var hasChapters = !!chapters.length;
  var hasTeams = !!teams.length;
  var hasPeople = !!people.length;
  if (loading) {
    return react_1.default.createElement(app_loader_1.AppLoader, null);
  }
  return react_1.default.createElement(My.Container, {
    className: className
  }, hasTeams && react_1.default.createElement(My.Teams, {
    showDescription: true,
    items: teams
  }), hasChapters && react_1.default.createElement(My.Chapters, {
    showDescription: true,
    items: chapters
  }), hasPeople && react_1.default.createElement(My.People, {
    showDescription: true,
    items: people
  }));
};
exports.MyNetworkRoute = MyNetworkRoute;
exports.MyNetworkRoute.defaultProps = exports.MyNetworkRouteDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;